import { Flex, Image } from "antd";
import { Fade } from "react-awesome-reveal";
import img from "../images/1.png";
import MyText from "../../../components/UI/Text/MyText";
import { clrs } from "../../../constants/colors";
import HorizontalDivider from "../../../components/Divider/HorizontalDivider";
import { Link } from "react-router-dom";
import { LinkOutlined } from "@ant-design/icons";
import React from "react";

export const PersonBiloshchytskyi = () => {
    return (
        <Flex style={{ width: "100%", position: "relative" }} vertical gap={20}>
            <Flex style={{ width: "100%", position: "relative" }} gap={40} wrap="wrap">
                <Fade triggerOnce={true} cascade damping={0.15}>
                    <Image src={img} width={240} preview={false} style={{ borderRadius: 16 }} />
                </Fade>
                <Flex style={{ flex: 1, minWidth: 200, position: "relative" }} vertical>
                    <MyText strong size={"large"}>Белощицкий Андрей Александрович</MyText>
                    <MyText style={{ color: clrs.whiterBlacker }}>Доктор технических наук, профессор, проректор по науке и инновациям Astana IT University</MyText>
                    <br />
                    <HorizontalDivider />
                    <br />
                    <Flex gap={12} wrap={"wrap"} vertical>
                        <Link target={"_blank"} to={'https://www.scopus.com/authid/detail.uri?authorId=57190487952'}>
                            <MyText><LinkOutlined /> Scopus</MyText>
                        </Link>
                        <Link target={"_blank"} to={'https://orcid.org/0000-0001-9548-1959'}>
                            <MyText><LinkOutlined /> ORCID</MyText>
                        </Link>
                    </Flex>
                    <br />
                    <MyText strong size={"small"}>Основное место работы, должность</MyText>
                    <MyText>Astana IT University, проректор по науке и инновациям</MyText>
                </Flex>
            </Flex>

            <Flex style={{ width: "100%", position: "relative" }} vertical>
                <MyText strong size={"small"}>Роль в проекте</MyText>
                <MyText size={"small"} italic>
                    Научный руководитель, куратор более 15 научных проектов государственного и международного уровней, включая Smart City, цифровую трансформацию и систему оценки научных исследований.
                </MyText>
            </Flex>

            <Flex style={{ width: "100%", position: "relative" }} vertical>
                <MyText strong size={"small"}>Краткое обоснование участия</MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    Опыт более 28 лет в науке и образовании. Автор более 300 научных работ, 6 учебников, 76 статей в международных индексируемых базах. Эксперт в области информационных технологий, IoT, систем управления, аналитических платформ и ГИС.
                </MyText>
            </Flex>

            <Flex style={{ width: "100%", position: "relative" }} vertical>
                <MyText strong size={"small"}>Научные проекты:</MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    - Руководитель — BR21882258 «Разработка комплекса ИКТ-систем для экологического мониторинга» (2023-2025).
                </MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    - Ответственный исполнитель — BR24993128 «Разработка ИАС для трансграничных водных ресурсов» (2024-2026), бюджет 650 000 000 тенге.
                </MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    - Руководитель — BR10965311 «Smart City: интеллектуальные системы городской инфраструктуры» (2021-2023), бюджет 390 000 000 тенге.
                </MyText>
            </Flex>
        </Flex>
    );
};
